import React from 'react';

/**
 * File: AzureDevOpsIcon.tsx
 * Description: Shell-branded (red) Azure DevOps icon used in the Codie TopBar.
 *   Renders the official Azure DevOps brand mark in Shell Red via `currentColor`.
 * Author: Archie Frontend
 */

interface AzureDevOpsIconProps {
  /** Pixel size of the square icon. Defaults to 20. */
  size?: number;
  className?: string;
}

/**
 * Red Azure DevOps icon: the official Azure DevOps brand mark rendered in
 * `currentColor` (Shell Red in the TopBar).
 *
 * @param size Square pixel size of the icon. Defaults to 20.
 * @param className Optional class applied to the root SVG.
 * @return The rendered icon element.
 */
export const AzureDevOpsIcon: React.FC<AzureDevOpsIconProps> = ({
  size = 20,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M0 8.877L2.247 5.91l8.405-3.416V.022l7.37 5.393L2.966 8.338v8.225L0 15.707zm24-4.45v14.651l-5.753 4.9-9.303-3.057v3.056l-5.978-7.416 15.057 1.798V5.415z" />
  </svg>
);

export default AzureDevOpsIcon;
